import { NgxGalleryOptions, NgxGalleryOrder } from '@speedy/core';

export const galleryOptions: NgxGalleryOptions[] = [
  {
    width: '100%',
    height: '600px',
    imagePercent: 100,
    imageSwipe: true,
    imageArrows: true,
    imageAnimation: 'slide',
    imageSize: 'contain',
    thumbnailsOrder: NgxGalleryOrder.Row,
    thumbnailsPercent: 20,
    thumbnailsColumns: 5,
    thumbnailsArrows: false,
    thumbnailsSwipe: true,
    thumbnailSize: 'contain',
    previewSwipe: true,
    previewCloseOnEsc: true,
    previewZoom: true,
    previewCloseOnClick: true,
    arrowPrevIcon: 'material-icons arrow_back_ios',
    arrowNextIcon: 'material-icons arrow_forward_ios',
    closeIcon: 'material-icons close',
    zoomInIcon: 'material-icons zoom_in',
    zoomOutIcon: 'material-icons zoom_out',
    spinnerIcon: 'material-icons refresh',
  },
  {
    breakpoint: 1280,
    imageSwipe: true,
  },
  {
    breakpoint: 922,
    height: '500px',
  },
  {
    breakpoint: 768,
    height: '450px',
  },
  {
    breakpoint: 576,
    height: '350px',
  },
];
